<div class="image-modal-overlay" (click)="closeModal()">
    <div class="image-modal-content" (click)="stopPropagation($event)">
      <button class="close-button" (click)="closeModal()">×</button>
      <div class="image-container">
        <img [src]="imageUrl" [alt]="altText" class="zoomed-image">
      </div>
      <div class="image-caption" *ngIf="altText">{{ altText }}</div>
    </div>
  </div>